// ACTIONS are the possible actions a user can make while using the app, they will be logged in GA as event_name
export const ACTIONS = {
  CLICK: "click",
  EXCEPTION: "exception",
  FILL: "fill",
  LOGIN: "login",
  SCREEN_VIEW: "screen_view",
  SEARCH: "search",
  SUBMIT: "submit",
  UPLOAD: "upload",
};

// CATEGORIES refer to the object the action is acting on. Normally, I like keeping constants as close to the logic
// its used in as possible, but I think for GA it is cleaner to organize everything here. 1). We can see all the objects
// we are tracking. 2) We won't have duplicates, hopefully
export const CATEGORIES = {
  DIRECTORY_SHOWS: "directory_shows",
  EPISODE_AUDIO: "episode_audio",
  EPISODE_FORM: "episode_form",
  EPISODE_IMAGE: "episode_image",
  FEED_INPUT_TOGGLE: "feed_input_toggle",
  IMPORT_FORM: "import_form",
  IMPORT_SHOW_BUTTON: "import_show_button",
  NEW_SHOW_BUTTON: "new_show_button",
  SHOW_FORM: "show_form",
  SHOW_IMAGE: "show_image",
  VERIFY_REDIRECT_BUTTON: "verify_redirect_button",
  VERIFY_REDIRECT_LINK: "verify_redirect_link",
};

// will emit a google analytics event
export const gtagEvent = (event_name, event_category, params) => {
  window.gtag("event", event_name, { event_category: event_category, ...params });
};
